import React from 'react';
import styles from './VisualEditor.css';

interface VisualEditorProps {
	setAmount: (event: React.ChangeEvent<HTMLInputElement>) => void,
	setPeriod: (event: React.ChangeEvent<HTMLInputElement>) => void,
	setPayer: (event: React.ChangeEvent<HTMLInputElement>) => void,
	setAddress: (event: React.ChangeEvent<HTMLInputElement>) => void,
}

const VisualEditor: React.FunctionComponent<VisualEditorProps> = ({ setAmount, setPeriod, setPayer, setAddress }) => (
	<div className={styles.visualEditor}>
		<div>
			<div className={styles.input}>
				<small className={styles.inputType}>Сумма платежа</small>
				<input
					className={styles.inputElement}
					placeholder="Введите сумму платежа"
					onChange={setAmount}
				/>
			</div>

			<div className={styles.input}>
				<small className={styles.inputType}>Период платежа</small>
				<input
					className={styles.inputElement}
					placeholder="Введите период платежа"
					onChange={setPeriod}
				/>
			</div>

			<div className={styles.input}>
				<small className={styles.inputType}>ФИО плательщика</small>
				<input
					className={styles.inputElement}
					placeholder="Введите ФИО плательщика"
					onChange={setPayer}
				/>
			</div>

			<div className={styles.input}>
				<small className={styles.inputType}>Адрес</small>
				<input
					className={styles.inputElement}
					placeholder="Введите адрес плательщика"
					onChange={setAddress}
				/>
			</div>
		</div>
	</div>
);

export default VisualEditor;
